import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@recruitee/ngrx';

import type { AuthorizePayload } from '../../services/o-auth-http-client';

export const OAuthAuthorizeActions = createActions('OAuthAuthorize', {
  authorize: ngrxEvent<AuthorizePayload>(),
  authorizeSuccess: ngrxEvent<{ code: string }>(),
  authorizeFailed: ngrxEvent<{ error: HttpErrorResponse }>(),

  deauthorize: ngrxEvent<{ clientId: string }>(),
  deauthorizeSuccess: ngrxEvent<void>(),
  deauthorizeFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
